import React from "react"
import Table from "material-ui/Table"
import TF from "material-ui/Table/TableFooter"
import TableHeaderColumn from "material-ui/Table/TableHeaderColumn"
import TableRow from "material-ui/Table/TableRow"
import TableHeader from "material-ui/Table/TableHeader"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import TableBody from "material-ui/Table/TableBody"
import TableFooter from "../../../components/layout/TableFooter"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import Chip from "material-ui/Chip"
import * as permissionHelper from "../../../helpers/permissionHelper"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import { IUserDocument } from "../../../models"
import { green500 } from "material-ui/styles/colors"

interface IProps {
	users: IUserDocument[]
	offset: number
	limit: number
	total: number
	limitOptions: number[]
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	handleSelectUser(selectedUsers: IUserDocument[]): void
	handleEditUser(editUser: IUserDocument): void
}
interface IState {
	selectedUsers: IUserDocument[]
	showTable: boolean
}

const styles = {
	columnValue: {
		cursor: "pointer",
		paddingLeft: "8px",
		paddingRight: "8px"
	},
	columnHeader: {
		paddingLeft: "8px",
		paddingRight: "8px",
		whitespace: "normal"
	},
	tableStyle: {
		overFlowY: "visible"
	}
}

export default class AccountUsersTable extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			selectedUsers: [],
			showTable: true
		}
		autobind(this)
	}

	allRowsSelection(rows) {
		rows === "all" && this.handleSelectUser(this.props.users.slice())
		rows === "none" && this.handleSelectUser([])
	}

	handelOnCellClick(rowNumber, columnId) {
		if (columnId === -1) {
			let { selectedUsers } = this.state
			const clickedUser = this.props.users[rowNumber]
			if (selectedUsers.every((user) => user.Id !== clickedUser.Id)) {
				selectedUsers.push(clickedUser)
			} else {
				selectedUsers = selectedUsers.filter((user) => user.Id !== clickedUser.Id)
			}
			this.handleSelectUser(selectedUsers)
		} else {
			this.props.handleEditUser(this.props.users[rowNumber])
		}
	}

	handleSelectUser(selectedUsers) {
		this.setState({ selectedUsers, showTable: false }, () => this.setState({ showTable: true }))
		this.props.handleSelectUser(selectedUsers)
	}

	render() {
		return (
			<Table
				multiSelectable
				bodyStyle={styles.tableStyle}
				onCellClick={this.handelOnCellClick}
				onRowSelection={this.allRowsSelection}
				allRowsSelected={this.props.users.length > 0 && this.props.users.every(item => (this.state.selectedUsers.find(selectedUser => item.Id === selectedUser.Id) ? true : false))}
			>
				<TableHeader>
					<TableRow>
						<TableHeaderColumn style={styles.columnHeader}>{strings.First_Name}</TableHeaderColumn>
						<TableHeaderColumn style={styles.columnHeader}>{strings.Last_Name}</TableHeaderColumn>
						<TableHeaderColumn style={styles.columnHeader}>{strings.Owner}</TableHeaderColumn>
						<TableHeaderColumn style={styles.columnHeader}>{strings.Hierarchy}</TableHeaderColumn>
						<TableHeaderColumn style={styles.columnHeader}>{strings.Role}</TableHeaderColumn>
					</TableRow>
				</TableHeader>
				<TableBody showRowHover={true} deselectOnClickaway={false}>
					{this.props.users.map((row, index) =>
						<TableRow data-intercom-target={index === 0 && "menu-AccountUsers-Users-openItemEditDialog"} key={index} selected={this.state.selectedUsers.find(user => user.Id === row.Id) ? true : false}>
							<TableRowColumn style={styles.columnValue}>{row.FirstName}</TableRowColumn>
							<TableRowColumn style={styles.columnValue}>{row.LastName}</TableRowColumn>
							<TableRowColumn style={styles.columnValue}>
								{row.Owner &&
									<i
									className="fa fa-check"
									style={{ fontSize: 18, color: green500 }}
								/>
								}
							</TableRowColumn>
							<TableRowColumn style={styles.columnValue}>{hierarchyHelper.getFullyQualifiedLevelNameById(row.OrganizationHierarchyId)}</TableRowColumn>
							<TableRowColumn style={styles.columnValue}>
								{permissionHelper.getUserRoleById(row.UserRoleId) &&
									<Chip>{permissionHelper.getUserRoleById(row.UserRoleId).Type}</Chip>
								}
							</TableRowColumn>
						</TableRow>)}
				</TableBody>
				<TF>
					<TableFooter
						onPageClick={this.props.onPageClick}
						offset={this.props.offset}
						limit={this.props.limit}
						total={this.props.total}
						onLimitChange={this.props.onLimitChange}
						limitOptions={this.props.limitOptions}
					/>
				</TF>
			</Table>
		)
	}
}
